module.exports = __webpack_public_path__ + "img/clip.d28acd30.svg";